import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { axios, useAuth } from '../contexts/AuthContext';

const ACTION_META = {
  LOGIN:  { icon:'🔑', bg:'linear-gradient(135deg,#E3F2FD,#BBDEFB)', color:'#1565C0', border:'rgba(21,101,192,0.2)' },
  LOGOUT: { icon:'🚪', bg:'linear-gradient(135deg,#F5F5F5,#EEEEEE)',  color:'#424242', border:'rgba(0,0,0,0.1)' },
  ADD:    { icon:'✅', bg:'linear-gradient(135deg,#E8F5E9,#C8E6C9)',  color:'#1B5E20', border:'rgba(27,94,32,0.2)' },
  EDIT:   { icon:'✏️', bg:'linear-gradient(135deg,#FFF8E1,#FFE082)',  color:'#E65100', border:'rgba(230,81,0,0.2)' },
  DELETE: { icon:'🗑️', bg:'linear-gradient(135deg,#FFEBEE,#FFCDD2)',  color:'#B71C1C', border:'rgba(183,28,28,0.2)' },
  IMPORT: { icon:'📥', bg:'linear-gradient(135deg,#E8EAF6,#C5CAE9)',  color:'#283593', border:'rgba(40,53,147,0.2)' },
  EXPORT: { icon:'📤', bg:'linear-gradient(135deg,#E0F2F1,#B2DFDB)',  color:'#004D40', border:'rgba(0,77,64,0.2)' },
  PRINT:  { icon:'🖨️', bg:'linear-gradient(135deg,#EDE7F6,#D1C4E9)',  color:'#4A148C', border:'rgba(74,20,140,0.2)' },
};

export default function Logs() {
  const navigate = useNavigate();
  const { isAdmin } = useAuth();
  const [tab, setTab]     = useState('voter');   // 'voter' | 'account'
  const [logs, setLogs]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage]   = useState(1);
  const [pages, setPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState('');

  // Voter tab filters
  const voterFilters   = ['', 'ADD', 'EDIT', 'DELETE', 'IMPORT', 'EXPORT', 'PRINT'];
  // Account tab filters
  const accountFilters = ['', 'ADD', 'EDIT', 'DELETE', 'LOGIN', 'LOGOUT'];

  const fetchLogs = async (p = 1) => {
    setLoading(true);
    try {
      const params = { page: p, limit: 50 };
      if (filter) params.action_type = filter;

      if (tab === 'voter') {
        params.entity_type = 'voter';
        params.exclude_types = 'LOGIN,LOGOUT';
      } else {
        params.entity_type = 'user';
        params.exclude_types = 'IMPORT,EXPORT,PRINT';
      }

      const { data } = await axios.get('/logs', { params });
      setLogs(data.logs);
      setTotal(data.total);
      setPages(data.pages);
      setPage(p);
    } catch {} finally { setLoading(false); }
  };

  useEffect(() => { setFilter(''); }, [tab]);
  useEffect(() => { fetchLogs(1); }, [filter, tab]);

  const fmt = ts => new Date(String(ts).replace(' ','T')+(String(ts).includes('Z')?'':'Z')).toLocaleString('en-IN', { timeZone:'Asia/Kolkata', day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit' });

  const currentFilters = tab === 'voter' ? voterFilters : accountFilters;

  return (
    <div style={{ minHeight:'100vh', background:'linear-gradient(160deg,#FFF4ED,#FFF8F0)', fontFamily:"'Outfit',sans-serif" }}>

      {/* Header */}
      <div className="app-header">
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <button className="back-btn" onClick={()=>navigate('/')}>←</button>
          <div>
            <div style={{ fontFamily:"'Baloo 2',sans-serif", fontWeight:700, fontSize:'1.1rem', color:'white' }}>📋 Activity Logs</div>
            <div style={{ fontSize:'0.7rem', opacity:.8, color:'white' }}>{total.toLocaleString()} entries</div>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display:'flex', background:'white', borderBottom:'2px solid rgba(255,107,0,0.12)', padding:'0 16px' }}>
        {[
          { id:'voter',   label:'🗳️ Voter Activity',   desc:'Added / Edited / Deleted voters' },
          ...(isAdmin ? [{ id:'account', label:'👤 Account Activity', desc:'User accounts / Login' }] : []),
        ].map(t => (
          <button key={t.id} onClick={()=>setTab(t.id)} style={{
            padding:'14px 20px', border:'none', cursor:'pointer', background:'none',
            fontFamily:"'Outfit',sans-serif", fontWeight:700, fontSize:'0.88rem',
            color: tab===t.id ? '#E55100' : '#9E6040',
            borderBottom: tab===t.id ? '3px solid #E55100' : '3px solid transparent',
            transition:'all 0.2s', marginBottom:-2,
          }}>
            {t.label}
          </button>
        ))}
      </div>

      {/* Tab description */}
      <div style={{ padding:'8px 20px', background:'rgba(255,107,0,0.04)', fontSize:'0.75rem', color:'#9E6040', borderBottom:'1px solid rgba(255,107,0,0.08)' }}>
        {tab === 'voter'
          ? '📊 Shows all voter records added, edited, deleted and imported by enumerators'
          : '👤 Shows account creations, logins and user management actions'}
      </div>

      {/* Filter chips */}
      <div style={{ display:'flex', gap:8, padding:'12px 16px', overflowX:'auto', background:'rgba(255,255,255,0.7)' }}>
        {(isAdmin ? currentFilters : ['','IMPORT','EXPORT','PRINT']).map(a => {
          const meta = a ? ACTION_META[a] : null;
          return (
            <button key={a} onClick={()=>setFilter(a)} style={{
              padding:'6px 14px', borderRadius:99, border:'none', cursor:'pointer',
              fontWeight:700, fontSize:'0.75rem', whiteSpace:'nowrap',
              background: filter===a ? 'linear-gradient(135deg,#E55100,#FF6B00)' : 'rgba(255,255,255,0.9)',
              color: filter===a ? 'white' : '#5C3010',
              boxShadow: filter===a ? '0 4px 14px rgba(255,107,0,0.35)' : '0 2px 8px rgba(0,0,0,0.06)',
              border: filter===a ? 'none' : '1.5px solid rgba(255,107,0,0.2)',
              transition:'all 0.2s', transform: filter===a ? 'scale(1.05)' : 'none', flexShrink:0,
            }}>
              {a ? `${meta?.icon} ${a}` : '📋 All'}
            </button>
          );
        })}
      </div>

      {/* Logs List */}
      <div style={{ maxWidth:900, margin:'0 auto', padding:'16px 16px 60px' }}>
        {loading ? (
          <div className="loader"><div className="spinner"/></div>
        ) : logs.length === 0 ? (
          <div style={{ textAlign:'center', padding:'48px', color:'#9E6040' }}>
            <div style={{ fontSize:'2.5rem', marginBottom:12 }}>📭</div>
            <div style={{ fontWeight:700 }}>No {tab === 'voter' ? 'voter' : 'account'} activity found</div>
          </div>
        ) : (
          <div>
            {logs.map(log => {
              const meta = ACTION_META[log.action_type] || ACTION_META.IMPORT;
              return (
                <div key={log.id} style={{ background:'rgba(255,255,255,0.9)', backdropFilter:'blur(12px)', borderRadius:16, padding:'14px 18px', marginBottom:10, display:'flex', gap:14, alignItems:'flex-start', border:`1px solid ${meta.border}`, borderLeft:`4px solid ${meta.color}`, boxShadow:'0 2px 12px rgba(0,0,0,0.05)', transition:'all 0.2s' }}
                onMouseEnter={e=>{e.currentTarget.style.transform='translateX(4px)'; e.currentTarget.style.boxShadow='0 8px 28px rgba(0,0,0,0.1)';}}
                onMouseLeave={e=>{e.currentTarget.style.transform='none'; e.currentTarget.style.boxShadow='0 2px 12px rgba(0,0,0,0.05)';}}>
                  <div style={{ width:40, height:40, borderRadius:'50%', flexShrink:0, background:meta.bg, border:`1px solid ${meta.border}`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.1rem' }}>{meta.icon}</div>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ fontWeight:700, fontSize:'0.87rem', color:'#1A0A00', marginBottom:2 }}>{log.description || `${log.action_type} on ${log.entity}`}</div>
                    <div style={{ fontSize:'0.75rem', color:'#9E6040' }}>by <strong style={{ color:'#5C3010' }}>{log.user_name}</strong></div>
                    <div style={{ fontSize:'0.72rem', color:'#C4A090', marginTop:2 }}>🕐 {fmt(log.created_at)}</div>
                  </div>
                  <span style={{ background:meta.bg, color:meta.color, padding:'3px 10px', borderRadius:99, fontSize:'0.7rem', fontWeight:700, border:`1px solid ${meta.border}`, flexShrink:0 }}>{log.action_type}</span>
                </div>
              );
            })}
          </div>
        )}

        {pages > 1 && (
          <div className="pagination">
            <button className="page-btn" onClick={()=>fetchLogs(page-1)} disabled={page===1}>‹</button>
            <span style={{ fontSize:'0.85rem', color:'#9E6040', padding:'0 12px', fontWeight:600 }}>Page {page} of {pages}</span>
            <button className="page-btn" onClick={()=>fetchLogs(page+1)} disabled={page===pages}>›</button>
          </div>
        )}
      </div>
    </div>
  );
}